import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { cardService } from '../../services/cardService';
import { vcardService } from '../../services/vcardService';
import { Spinner } from '../../components/ui/Spinner';
import { Button } from '../../components/ui/Button';
import { SaveContactInstructions } from '../../components/public/SaveContactInstructions';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const VCardRoute = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchCard = async () => {
      try {
        const result = await cardService.getPublicCardBySlug(slug);
        setData(result);
        
        // Auto-download attempt when the route loads
        if (result?.card) {
          document.title = `Save Contact: ${result.card.full_name} | Meetoi`;
          vcardService.generateAndDownload(result.card);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    if (slug) fetchCard();
  }, [slug]);

  const handleRetry = () => {
    if (data?.card) {
      vcardService.generateAndDownload(data.card);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center bg-slate-50">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4 text-center">
        <div className="w-16 h-16 bg-slate-200 text-slate-400 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon={FiIcons.FiUserX} className="text-3xl" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">This Meetoi contact is unavailable</h1>
        <p className="text-slate-600 max-w-md mx-auto mb-8">
          The card may have been unpublished, archived, or the link may be incorrect.
        </p>
        <Link to="/">
          <Button>Go to Meetoi</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 flex flex-col items-center justify-center">
      <SaveContactInstructions onRetry={handleRetry} isInline={true} />
      <div className="mt-8">
        <Link to={`/c/${data.card.public_slug}`}>
          <Button variant="ghost">View Digital Card</Button>
        </Link>
      </div>
    </div>
  );
};